import React from "react";
import Reveal from "./Reveal";
import { Leaf, Recycle, Gauge, CircuitBoard } from "lucide-react";

const items = [
  { icon: Gauge, title: "Efficient distribution", body: "Right-sized pumps, balanced risers and pressure-zoning that lowers lifetime water and energy demand." },
  { icon: Recycle, title: "Greywater & reuse readiness", body: "Plumbing layouts that anticipate dual-pipe and rainwater-harvesting integration where required." },
  { icon: Leaf, title: "Material discipline", body: "Considered specification of pipes, fittings and insulation to extend service life and reduce waste." },
  { icon: CircuitBoard, title: "Modern engineering standards", body: "Up-to-date with IS, NBC and IPC references — backed by hydrostatic testing protocols on every site." },
];

export const Sustainability = () => {
  return (
    <section data-testid="sustainability-section" className="relative py-28 md:py-40 bg-ink-900">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 lg:px-16">
        <div className="grid grid-cols-12 gap-10">
          <div className="col-span-12 lg:col-span-5">
            <Reveal>
              <span className="font-mono text-[11px] uppercase tracking-[0.32em] text-gold">
                / 06 — Modern Engineering
              </span>
            </Reveal>
            <Reveal delay={120}>
              <h2 className="mt-6 font-display text-4xl md:text-5xl lg:text-6xl text-white leading-[1.05] tracking-tight">
                Built to <span className="italic text-gold">outlast</span> the buildings they serve.
              </h2>
            </Reveal>
            <Reveal delay={200}>
              <p className="mt-8 text-base text-steel-light leading-relaxed">
                Good plumbing is, quietly, an environmental discipline. The right sizing, the
                right material, the right joint — repeated over decades — adds up to
                meaningful savings of water, energy and embodied carbon.
              </p>
            </Reveal>
          </div>

          <div className="col-span-12 lg:col-span-7">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-px bg-white/5 border border-white/5">
              {items.map((it, i) => {
                const Icon = it.icon;
                return (
                  <Reveal
                    key={it.title}
                    delay={i * 100}
                    className="bg-ink-800 p-8 hover:bg-ink-700 transition-colors duration-300"
                    data-testid={`sustain-card-${i}`}
                  >
                    <Icon size={24} strokeWidth={1.25} className="text-gold" />
                    <h4 className="mt-6 font-display text-2xl text-white leading-tight">
                      {it.title}
                    </h4>
                    <p className="mt-3 text-sm text-steel-light leading-relaxed">
                      {it.body}
                    </p>
                  </Reveal>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Sustainability;
